import React from 'react';
import {NavLink} from 'react-router-dom';
import {Tooltip, Typography} from 'antd';

const MenuBuilder = menus => {
  let listOfMenus = [];

  const buildMenu = menu => {
    const convertedMenu = convertToMenu(menu);
    if (menu.children && menu.children.length > 0) {
      const childrenMenus = menu.children.map(child => buildMenu(child));
      convertedMenu.children = childrenMenus;
    }
    return convertedMenu;

  };

  menus.forEach(menu => {
    const builtMenu = buildMenu(menu);
    listOfMenus.push(builtMenu);
  });

  return listOfMenus;
};

const convertToMenu = menu => {
  let target = '_self';
  if (menu.actionUrl.indexOf('/app') === 0) {
    menu.actionUrl = menu.actionUrl.replace('/app', '');
  }
  if (menu.actionUrl.indexOf('https://') === 0) {
    target = '_blank';
  }
  {return {
    key: menu.id.id,
    label: (
      <Tooltip
        placement={'right'}
        title={generateLabel(menu)}
        mouseEnterDelay={0.3}
        overlayStyle={{zIndex: 2000}}
      >
        <NavLink
          to={menu.actionUrl}
          target={target}
          style={{
            display: 'inline-block',
            maxWidth: '150px', // limit width for ellipsis
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            verticalAlign: 'middle',
          }}
        >
          {generateLabel(menu)}
        </NavLink>
      </Tooltip>

    // <NavLink to={menu.actionUrl} target={target}>
    //     <Tooltip placement={'right'} title={generateLabel(menu)}>
    //       <span>{generateLabel(menu)}</span>
    //     </Tooltip>
    //   </NavLink>
    ),
  };}
};

const generateLabel = menu => {
  if (menu.name && menu.name !== '') {
    return menu.name;
  } else {
    return <Typography.Title level={5}>{menu.label}</Typography.Title>;
  }
};

export default MenuBuilder;
